import {
    useGetHistoricalForecastDataMutation,
    useGetFutureForecastDeepDiveDataMutation,
} from "../api/deepdive";

export const useGetHistoricalForecastData = () => {
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetHistoricalForecastDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    }
}

export const useGetFutureForecastDeepDiveData = () => {
    const [mutate, {isLoading, isSuccess, isError, error, data}] = useGetFutureForecastDeepDiveDataMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    }
}